import * as React from 'react';
import { discoverNFTData, } from '../../Shared/FackeDataFactory';
import { HomeRightSide } from './HomeRightSide/HomeRightSide';
import { NavLink } from 'react-router-dom';
import { AnimatePresence, motion } from "framer-motion"

import my_profile from '../../assets/images/my_profile.png';

import './Home.scss';
import ScrollContainer from 'react-indiana-drag-scroll';
import { Posts } from './Posts/Posts';
import { CreatePost } from './Posts/CreatePost/CreatePost';

export interface IAppProps {

}

export function Home(props: IAppProps) {
    const [createPostModalOpen, setCreatePostModalOpen] = React.useState(false)
    const createPostModalRef = React.useRef(null)
    // useClickOutside(createPostModalRef, () => setCreatePostModalOpen(false))



    return (
        <div>
            <div className="mx-auto xs:flex-col xl:flex-row flex justify-between home_main_box my-32
            py-0 px-[15px]
            sm:max-w-[540px]
            md:max-w-[590px]
            lg:max-w-[650px]
            xl:max-w-[1068px]
            2xl:max-w-[1280px]
            3xl:max-w-[1300px]
            ">
                {/* <canvas id="myCanvas" className="hidden"></canvas> */}


                {/* Left side Section----------------- */}
                <div className="flex-1 text-left xs:order-2 xl:order-1">


                    <div className="relative inline-block">
                        <h1 className="xs:text-xl sm:text-2xl xl:text-3xl mr-3 dark:font-bold font-black text-cusBlack dark:text-white">Discover NFT</h1>

                        <div className="bottom-1 absolute -right-4">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={12} height={12} viewBox="0 0 12 12">
                                <defs>
                                    <linearGradient id="linear-gradient" x1="0.875" y1="0.174" x2="0.139" y2="0.84" gradientUnits="objectBoundingBox">
                                        <stop offset={0} stopColor="#00dbff" />
                                        <stop offset="0.529" stopColor="#e315e8" />
                                        <stop offset={1} stopColor="#ffd817" />
                                    </linearGradient>
                                </defs>
                                <circle id="Ellipse_1" data-name="Ellipse 1" cx={6} cy={6} r={6} fill="url(#linear-gradient)" />
                            </svg>
                        </div>
                    </div>


                    <ScrollContainer
                        nativeMobileScroll={true}
                        horizontal={true}
                        className="scroll-container mb-8 xs:mt-3 md:mt-8 flex xs:space-x-3 sm:space-x-5 xl:space-x-3 2xl:space-x-5 overflow-auto ">
                        {discoverNFTData.slice(0, 4).map((data, index) =>
                            <div key={data.id}>
                                <div className="xs:w-36 sm:w-44 xl:w-full">
                                    <img src={data.thumImage} alt="" className="w-full" />
                                </div>
                                <div className="mt-4 flex justify-start items-center">
                                    <NavLink to="/publicProfile/activity">
                                        <motion.div
                                            whileTap={{ scale: 0.8 }}
                                            transition={{ duration: 0.2 }}
                                            className="discover_profile_pic w-[39px] h-[39px] sm:w-[42px] sm:h-[42px] md:w-[46px] md:h-[46px] rounded-full flex justify-center items-center">
                                            <div className="rounded-full w-[35px] h-[35px] sm:w-[35px] sm:h-[38px] md:w-[42px] md:h-[42px] border-2 dark:border-[#140D36] border-white">
                                                <img src={data.photo} alt="" className="w-full h-full" />
                                            </div>
                                        </motion.div>
                                    </NavLink>
                                    <div className="xs:ml-3 xl:ml-2 2xl:ml-3 text-left">
                                        <h4 className="xs:text-sm sm:text-base xl:text-xs 2xl:text-sm 3xl:text-base text-cusBlack dark:text-white">{data.name}</h4>
                                        <p className="text-sm text-cusBlack dark:text-cusBlueWhite">${data.price.toLocaleString()}</p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </ScrollContainer>


                    <div className="xs:block md:hidden">
                        <HomeRightSide />
                    </div>


                    <div className="text-left">
                        <div className="relative inline-block mt-10">
                            <h1 className="xs:text-xl sm:text-2xl xl:text-3xl mr-8 font-extrabold text-cusBlack dark:text-white">Connect</h1>
                            <div className="bottom-1 absolute -right-4">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={12} height={12} viewBox="0 0 12 12">
                                    <defs>
                                        <linearGradient id="linear-gradient" x1="0.875" y1="0.174" x2="0.139" y2="0.84" gradientUnits="objectBoundingBox">
                                            <stop offset={0} stopColor="#00dbff" />
                                            <stop offset="0.529" stopColor="#e315e8" />
                                            <stop offset={1} stopColor="#ffd817" />
                                        </linearGradient>
                                    </defs>
                                    <circle id="Ellipse_1" data-name="Ellipse 1" cx={6} cy={6} r={6} fill="url(#linear-gradient)" />
                                </svg>
                            </div>
                        </div>

                        <div className="lightBlueBg w-full xs:p-2 sm:p-4 xs:mt-3 md:mt-5 rounded-lg sm:rounded-xl md:rounded-2xl flex justify-between items-center">
                            <div className="flex justify-start items-center">
                                <NavLink to="/profile/activity">
                                    <motion.div
                                        whileHover={{ scale: 1.1 }}
                                        whileTap={{ scale: 0.99 }}
                                        className="discover_profile_pic w-[39px] h-[39px] sm:w-[42px] sm:h-[42px] md:w-[46px] md:h-[46px] rounded-full flex justify-center items-center">
                                        <div className="rounded-full w-[42px] h-[42px] border-2 dark:border-[#140D36] border-white">
                                            <img src={my_profile} alt="" className="w-full h-full" />
                                        </div>
                                    </motion.div>
                                </NavLink>
                                <p className="xs:text-xs sm:text-lg ml-4 text-cusBlack dark:text-white">Hi, Donald Trump</p>
                            </div>

                            <NavLink to="/createNewCollection" className="gradientBtn text-center xs:px-3 sm:px-6 md:px-8 py-2.5 rounded-md text-white xs:text-xxs sm:text-base">
                                Create New Collection
                            </NavLink>
                        </div>
                    </div>





                    {/* Create Post */}
                    <div className="text-left mt-7 md:mt-14">
                        <div className="lightBlueBg w-full xs:p-2 sm:p-4 xs:mt-3 md:mt-5 rounded-lg sm:rounded-xl md:rounded-2xl">
                            <div className="flex justify-start items-center">
                                <NavLink to="/profile/activity">
                                    <motion.div
                                        whileTap={{ scale: 0.99 }}
                                        whileHover={{ scale: 1.1 }}
                                        className="rounded-full w-9 h-9 sm:w-11 sm:h-11 overflow-hidden">
                                        <img src={my_profile} alt="" className="w-full h-full" />
                                    </motion.div>
                                </NavLink>
                                <motion.button
                                    whileHover={{ scale: 1.009 }}
                                    whileTap={{ scale: 0.99 }}
                                    transition={{ duration: 0.1 }}
                                    onClick={() => setCreatePostModalOpen(!createPostModalOpen)}
                                    className="bg-[#efefef] hover:bg-[#dadada] dark:bg-[#363375] dark:hover:bg-[#3f3d88] px-5 py-2.5 ml-3 w-full
                                     rounded-full flex-1 text-left text-l-LightBlack dark:text-[#8481c9] outline-none transition-all
                                     text-xs sm:text-sm md:text-base
                                ">
                                    Click to create a new post
                                </motion.button>
                            </div>
                        </div>




                        <AnimatePresence>
                            {createPostModalOpen &&
                                <CreatePost
                                    createPostModalOpen={createPostModalOpen}
                                    setCreatePostModalOpen={setCreatePostModalOpen}
                                    createPostModalRef={createPostModalRef}
                                />
                            }
                        </AnimatePresence>



                    </div>





                    <Posts />

                </div>




                <div className="xs:hidden md:block xl:order-2 xs:mb-10">
                    <HomeRightSide />
                </div>

            </div>
        </div >
    );
}
